module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.load
    }
  }, [(_vm.dataFetched) ? _c('b-card', {
    staticClass: "mb-2",
    class: {
      'group-settlement-cancelled-card': _vm.groupSettlementCancelled, 'group-settlement-settled-card': _vm.groupSettlementSettled, 'group-settlement-active-card': _vm.groupSettlementActive
    },
    attrs: {
      "header-text-variant": "dark",
      "border-variant": _vm.groupSettlementCancelled || _vm.groupSettlementInvalid ? 'danger' : null,
      "header-border-variant": _vm.groupSettlementCancelled || _vm.groupSettlementInvalid ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementSingle'),
      "alternativeRoute": "group-settlement/group-settlement-information"
    }
  }, [_c('template', {
    slot: "badges"
  }, [_c('span', [(_vm.groupSettlementCancelled) ? _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.badgeCancelled')))]) : _vm._e(), _vm._v(" "), (_vm.groupSettlementSettled) ? _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.badgeSettled')))]) : _vm._e(), _vm._v(" "), (_vm.groupSettlementInvalid) ? _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.badgeInvalid')))]) : _vm._e()], 1)])], 2)], 1), _vm._v(" "), (_vm.groupSettlementInvalid || _vm.groupSettlementFlagged) ? _c('b-card', {
    staticClass: "text-center mb-3",
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.groupSettlementInvalidBanner')) + "\n            "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "link-text",
    attrs: {
      "href": _vm.activationDocumentationLink
    }
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.groupSettlementActivateLink')))])])]) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.groupSettlementNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.groupSettlement.groupSettlementNumber) + "\n          ")])])], 1), _vm._v(" "), (!!_vm.groupSettlement.createdName) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.groupSettlementCreator')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'userInfoPage',
        params: {
          userId: _vm.groupSettlement.createdId
        }
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.groupSettlement.createdName ? _vm.groupSettlement.createdName : _vm.groupSettlement.createdId) + "\n            ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.hasInvoiceReviewAllClaim) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnDebtor')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'approvedUserPage',
        params: {
          registrationId: _vm.groupSettlement.debtorId
        }
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.groupSettlement.debtorName ? _vm.groupSettlement.debtorName : _vm.groupSettlement.debtorId) + "\n            ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.canReportIssue) ? _c('b-col', [_c('b-img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "report-image",
    attrs: {
      "title": _vm.$t('general.technicalSupport'),
      "right": "",
      "src": require("@/assets/images/report-issue.svg")
    },
    on: {
      "click": _vm.reportSettlementIssue
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnAmount')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.formatAmount(_vm.groupSettlement.amount)) + "\n          ")])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnCreationDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.groupSettlement.creationDate)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnCreditor')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'approvedUserPage',
        params: {
          registrationId: _vm.groupSettlement.creditorId
        }
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.groupSettlement.creditorName ? _vm.groupSettlement.creditorName : _vm.groupSettlement.creditorId) + "\n            ")])], 1)])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnDueDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.formatShortDate(_vm.groupSettlement.dueDate)) + "\n          ")])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnInvoiceCount')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.groupSettlement.invoiceCount) + "\n          ")])])], 1), _vm._v(" "), (_vm.groupSettlement.settlementDate) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnSettlementDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.formatShortDate(_vm.groupSettlement.settlementDate)) + "\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnStatus')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('groupSettlement.groupSettlementStatus.' + _vm.groupSettlement.groupSettlementStatus)) + "\n          ")])])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('span', {
    staticClass: "col-form-legend"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.invoiceTableHeader')) + "\n        ")]), _vm._v(" "), (!_vm.showMassAdditionInput && _vm.isGroupSettlementEditable && !_vm.hasInvalidInvoices) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementAddInvoices'),
      "disabled": !_vm.isGroupSettlementEditable || _vm.hasInvalidInvoices,
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.showAddInvoicesInput
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("playlist_add")])]) : _vm._e(), _vm._v(" "), (_vm.showMassAdditionInput) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementCancelAddInvoices'),
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.hideAddInvoicesInput
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "md-auto"
    }
  }, [(_vm.showTable && _vm.isGroupSettlementEditable) ? _c('b-button', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementInvoicesShowInput')
    },
    on: {
      "click": _vm.toggleShowTable
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("list")])]) : _vm._e(), _vm._v(" "), (_vm.showTable && !_vm.isGroupSettlementEditable) ? _c('b-button', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementInvoicesShowText')
    },
    on: {
      "click": _vm.toggleShowTable
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("notes")])]) : _vm._e(), _vm._v(" "), (!_vm.showTable) ? _c('b-button', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementInvoicesShowTable')
    },
    on: {
      "click": _vm.toggleShowTable
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("table_chart")])]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showMassAdditionInput) ? _c('b-row', [_c('b-col', [_c('b-form-fieldset', [_c('b-form-textarea', {
    staticClass: "monospace-input",
    attrs: {
      "rows": 15,
      "max-rows": 32,
      "placeholder": _vm.$t('groupSettlement.massAdditionalInput')
    },
    model: {
      value: (_vm.massAdditionInput),
      callback: function($$v) {
        _vm.massAdditionInput = $$v
      },
      expression: "massAdditionInput"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showMassAdditionInput) ? _c('b-row', [_c('b-col', [_c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.groupSettlementAddInvoice
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementAddInvoice')) + "\n          "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAdditionalErrorContainer && _vm.showMassAdditionInput) ? _c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.additionalErrorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [(_vm.showTable) ? _c('b-col', [_c('b-row', [_c('b-col', {
    staticClass: "mt-2"
  }, [_c('b-table', {
    attrs: {
      "hover": "",
      "responsive": "",
      "items": _vm.tableItems,
      "fields": _vm.invoiceTableFields
    },
    scopedSlots: _vm._u([{
      key: "settlementAmount",
      fn: function(data) {
        return [_vm._v("\n                " + _vm._s(_vm.formatAmount(data.item.settlementAmount)) + "\n              ")]
      }
    }, {
      key: "cell(status)",
      fn: function(data) {
        return [_c('b-link', {
          staticClass: "invisible-link",
          attrs: {
            "to": {
              name: 'singleInvoiceRoute',
              params: {
                invoiceId: data.item.invoiceId
              }
            },
            "target": "_blank"
          }
        }, [(data.item.currentInvoiceStatus === _vm.invoiceStatus.SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : (data.item.currentInvoiceStatus === _vm.invoiceStatus.ACTIVE || data.item.currentInvoiceStatus === _vm.invoiceStatus.PROINVOICE) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + data.item.currentInvoiceStatus)))]) : (data.item.currentInvoiceStatus === _vm.invoiceStatus.PARTIALLY_SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + data.item.currentInvoiceStatus)))]) : (data.item.currentInvoiceStatus === _vm.invoiceStatus.ASSIGNED) ? _c('button', {
          staticClass: "btn btn-sm btn-warning"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + data.item.currentInvoiceStatus)))]) : _c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-danger': data.item.currentInvoiceStatus === _vm.invoiceStatus.CANCELLED
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + data.item.currentInvoiceStatus)))])])]
      }
    }, {
      key: "cell(invoiceId)",
      fn: function(data) {
        return [_c('b-link', {
          staticClass: "invisible-link",
          attrs: {
            "to": {
              name: 'singleInvoiceRoute',
              params: {
                invoiceId: data.item.invoiceId
              }
            },
            "target": "_blank"
          }
        }, [_vm._v("\n                  " + _vm._s(data.item.invoiceId) + "\n                ")])]
      }
    }, {
      key: "cell(settlementAmount)",
      fn: function(data) {
        return [_c('b-link', {
          staticClass: "invisible-link",
          attrs: {
            "to": {
              name: 'singleInvoiceRoute',
              params: {
                invoiceId: data.item.invoiceId
              }
            },
            "target": "_blank"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.formatAmount(data.item.settlementAmount)) + "\n                ")])]
      }
    }, {
      key: "cell(selected)",
      fn: function(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "id": 'checkbox' + data.index
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: (data.item.selected),
            callback: function($$v) {
              _vm.$set(data.item, "selected", $$v)
            },
            expression: "data.item.selected"
          }
        })]
      }
    }, {
      key: "cell(errorCode)",
      fn: function(data) {
        return [(data.item.errorCode !== null) ? _c('b-link', {
          staticClass: "invisible-link",
          attrs: {
            "to": {
              name: 'singleInvoiceRoute',
              params: {
                invoiceId: data.item.invoiceId
              }
            },
            "target": "_blank"
          }
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger",
          attrs: {
            "title": _vm.$t('apiStatusCodes.' + data.item.errorCode)
          }
        }, [_vm._v(_vm._s(_vm.$t('groupSettlement.invoiceError')))])]) : _vm._e()]
      }
    }], null, false, 2664991215)
  })], 1)], 1), _vm._v(" "), ((_vm.isGroupSettlementEditable && _vm.hasInvalidInvoices) || _vm.isGroupSettlementEditable) ? _c('b-row', [_c('b-col', [_c('div', [(_vm.isGroupSettlementEditable && _vm.hasInvalidInvoices) ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "title": _vm.$t('groupSettlement.selectInvalidInvoices'),
      "variant": "secondary"
    },
    on: {
      "click": _vm.selectInvalidInvoices
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("ballot")])]) : _vm._e(), _vm._v(" "), (_vm.isGroupSettlementEditable) ? _c('b-button', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementRemoveInvoice'),
      "variant": "danger",
      "disabled": !_vm.canRemoveInvocie
    },
    on: {
      "click": _vm.groupSettlementRemoveInvoice
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete_sweep")]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1)])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.showTable && !_vm.isGroupSettlementEditable) ? _c('b-col', [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.groupSettlement.groupSettlementItems), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item",
      class: {
        'group-settlement-settled-card-list': _vm.groupSettlementSettled,
        'list-group-item-danger': [_vm.invoiceStatus.CANCELLED, _vm.invoiceStatus.INVALID].includes(item.status),
          'list-group-item-success': [_vm.invoiceStatus.SETTLED].includes(item.status)
      }
    }, [_vm._v("\n            " + _vm._s(item.invoiceId) + " " + _vm._s(item.settlementAmount) + "\n          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.showTable && _vm.isGroupSettlementEditable) ? _c('b-col', [_c('b-row', [_c('b-col', [_c('b-form-fieldset', [_c('b-form-textarea', {
    staticClass: "monospace-input",
    attrs: {
      "rows": 15,
      "max-rows": 32
    },
    model: {
      value: (_vm.massInput),
      callback: function($$v) {
        _vm.massInput = $$v
      },
      expression: "massInput"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.isGroupSettlementEditable) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editSingleConfirmationModal",
      modifiers: {
        "editSingleConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "primary",
      "disabled": _vm.load
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('groupSettlement.groupSettlementEditSave')) + "\n              "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showActivateButton) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.groupSettlementActivateConfirmationModal",
      modifiers: {
        "groupSettlementActivateConfirmationModal": true
      }
    }],
    attrs: {
      "variant": _vm.showActivateButton ? 'primary' : 'secondary',
      "disabled": _vm.load || _vm.hasInvalidInvoices,
      "title": !_vm.hasInvalidInvoices ? _vm.$t('groupSettlement.groupSettlementActivateTitle') : _vm.$t('groupSettlement.groupSettlementActivateTitleDisabled')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('groupSettlement.groupSettlementActivate')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showDeactivateButton) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.load,
      "title": _vm.$t('groupSettlement.groupSettlementDeactivateTitle')
    },
    on: {
      "click": _vm.groupSettlementDeactivate
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('groupSettlement.groupSettlementDeactivate')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showCancelButton) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.groupSettlementCancelConfirmationModal",
      modifiers: {
        "groupSettlementCancelConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load,
      "title": _vm.$t('groupSettlement.groupSettlementCancelTitle')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('groupSettlement.groupSettlementCancel')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "groupSettlementActivateConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.groupSettlementActivate
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementActivationConfirmation')) + "\n      ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "groupSettlementCancelConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.groupSettlementCancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementCancelationConfirmation')) + "\n      ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editSingleConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateBeforeSubmit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('groupSettlement.groupSettlementEditConfirmation')) + "\n      ")])], 1)], 1) : (_vm.hasErrorWhenFetchingData) ? _c('b-card', [_c('b-row', [_c('b-col', [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementFetchingDataFailed')) + "\n        ")])])], 1)], 1) : _c('b-card', [_c('b-row', [_c('b-col', [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementFetchingData')) + "\n        ")])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "reportIssueModal",
    attrs: {
      "title": _vm.currentIssue === this.IssueCategory[0] ? _vm.$t('issues.reportIssueLiability') : _vm.$t('issues.reportIssueSettlement'),
      "header-bg-variant": "warning",
      "ok-title": _vm.$t('forms.send'),
      "size": "lg",
      "ok-only": ""
    },
    on: {
      "ok": _vm.submitIssueReport
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportId')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.currentIssueReport.resourceId),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "resourceId", $$v)
      },
      expression: "currentIssueReport.resourceId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportCategories')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.formattedIssueCategories
    },
    on: {
      "input": _vm.categoryChanged
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.currentIssueCategory && _vm.currentIssueCategory.requiresData) ? _c('div', [(_vm.currentIssue.ID === _vm.IssueCategory[1].ID && _vm.currentIssueCategory.id === 3) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "issues.amount"
    },
    model: {
      value: (_vm.currentIssueAmount),
      callback: function($$v) {
        _vm.currentIssueAmount = $$v
      },
      expression: "currentIssueAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentIssue.ID === _vm.IssueCategory[1].ID && _vm.currentIssueCategory.id === 4 && _vm.hasInvoiceSettlements) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementId')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceSettlementIDs
    },
    model: {
      value: (_vm.currentIssueSettlementId),
      callback: function($$v) {
        _vm.currentIssueSettlementId = $$v
      },
      expression: "currentIssueSettlementId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "issues.amount"
    },
    model: {
      value: (_vm.currentIssueAmount),
      callback: function($$v) {
        _vm.currentIssueAmount = $$v
      },
      expression: "currentIssueAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentIssue.ID === _vm.IssueCategory[0].ID && _vm.currentIssueCategory.id === 1) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceFields,
      "state": false
    },
    model: {
      value: (_vm.currentIssueReport.data),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "data", $$v)
      },
      expression: "currentIssueReport.data"
    }
  })], 1)], 1)], 1) : _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": false
    },
    model: {
      value: (_vm.currentIssueReport.data),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "data", $$v)
      },
      expression: "currentIssueReport.data"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "field-description"
  }, [_vm._v(_vm._s(_vm.currentIssueCategory.dataDescriptionCyr))])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportUserComment')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIssueReport.userComment),
      expression: "currentIssueReport.userComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentIssueReport.userComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIssueReport, "userComment", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), (_vm.currentIssueCategory && _vm.currentIssueCategory.categoryHelp) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.currentIssueCategory.categoryDescriptionCyr))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#fa9a4b"
    },
    attrs: {
      "href": _vm.helpLink(_vm.currentIssueCategory.categoryHelp),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueHelpLink')))])])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5607ae6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/group-settlement/single-group-settlement/SingleGroupSettlement.vue
// module id = 789
// module chunks = 1